import axios from 'axios';

export const axiosInstance = axios.create({
  baseURL: 'https://api.precisioncontractservices.com/public/api',
  // baseURL: 'https://ztpl.net/precisioncontractcleaning/backend/public/api',
  // baseURL: 'https://apidemo.precisioncontractservices.com/public/api',
});

export const config = {
  appUrl: '/',
  imageurl: 'https://api.precisioncontractservices.com/public/images/',
  websiteUrl: 'https://www.precisioncontractservices.com',

  // websiteUrl: 'https://demo.precisioncontractservices.com',
  // imageurl: 'https://apidemo.precisioncontractservices.com/public/images/',

  // appUrl: '/precisioncontractcleaning/',
  // imageurl: 'https://ztpl.net/precisioncontractcleaning/backend/public/images/',
  // websiteUrl: 'https://ztpl.net/precisioncontractcleaning',
};
